import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Box, showSuccessToast, showWarningToast, Text } from 'core/components';
import { Field, FormDialog } from 'core/form';
import AgentSelector from '../components/agentSelector/AgentSelector';

@inject('$syn')
@observer
export default class UpdateConfigAgentFormDialog extends Component {
  onSubmit = (form, values) => {
    const { $syn, refreshDetails } = this.props;

    return $syn.requests
      .updateConfigAgentOrTarget({ old_agent: form.model.id, new_agent: values.agent })
      .then((resp = {}) => {
        const { new_agent, old_agent, error_msg = null } = resp;
        if (!error_msg) {
          showSuccessToast(`Agent ${old_agent} was updated successfully with data from ${new_agent}.`, {
            title: 'Agent was successfully updated',
            timeout: 60000
          });
        } else {
          showWarningToast(`${error_msg}. Agent ${old_agent} was not updated with data from ${new_agent}.`, {
            title: 'There was a problem updating this agent',
            timeout: 60000
          });
        }
        return $syn.agents.fetch({ force: true }).then(() => refreshDetails());
      });
  };

  render() {
    const { onClose, model, ...rest } = this.props;
    const agent_alias = model.get('agent_alias');
    const fields = {
      agent: {
        rules: ['required', `not_in:${model.id}`],
        messages: { required: 'One agent selections is required' }
      }
    };
    return (
      <FormDialog
        {...rest}
        model={model}
        fields={fields}
        options={{ name: 'Synthetic Agent Migrate Form' }}
        title={`Update Tests Using ${agent_alias} (${model.id}) to use a New Agent`}
        isOpen
        onClose={onClose}
        formActionsProps={{
          confirmSubmit: true,
          confirmBodyContent: (
            <Text>
              Please confirm you would like to update tests using{' '}
              <Text fontWeight="heavy">
                {agent_alias} ({model.id})
              </Text>{' '}
              to use the new agent?
            </Text>
          ),
          onSubmit: this.onSubmit,
          onCancel: onClose,
          submitButtonText: 'Submit'
        }}
        width={720}
      >
        <Box overflow="auto" height={500}>
          <Field name="agent" large mb={0} showError={false}>
            <AgentSelector
              // TODO: deprecate browserAgents #7660
              hideNetworkAgents={model.isBrowser}
              hidePrivateAgents
              hideGlobalAgents={false}
              showPendingAgents={false}
              inlineForm
              multi={false}
              required
              showIdColumn
            />
          </Field>
        </Box>
      </FormDialog>
    );
  }
}
